/**
 * @module Cart/_components/EmptyCart
 */

import Link from "next/link";
import { Paragraph, Title } from "@/components/ui/typography";
import { ShoppingCart } from "lucide-react";

/**
 * EmptyCart component that displays a message when the cart is empty.
 * @function EmptyCart
 * @returns {JSX.Element} The rendered empty cart message
 *
 * @example
 * // Basic usage
 * <EmptyCart />
 */
export default function EmptyCart() {
  return (
    <div className="flex  flex-col items-center justify-center  h-screen">
      <div className="w-[40px] h-[40px] bg-midnightIndigo-400 rounded flex items-center justify-center p-[8px]">
        <ShoppingCart className="w-[24px] h-[24px] text-white" />
      </div>
      <Title size="lg" className="mt-3">
        {" "}
        Your cart is empty
      </Title>
      <Paragraph className="text-center mt-2 text-midnightIndigo-350">
        {" It looks like you haven't added anything to"}
        <br /> your cart yet.
      </Paragraph>
      <Link
        href="/products"
        className="outline outline-1 outline-midnightIndigo-200 hover:outline-midnightIndigo-400 p-2 text-[14px] md:text-[16px] rounded w-auto md:w-[150px]  mt-6"
      >
        Continue shopping
      </Link>
    </div>
  );
}
